import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const expensesTotalWidget: DashboardWidgetConfiguration = {
  widgetId: "expenses.total",
  name: "Total expenses",
  description: "Total expenses for the selected dashboard period.",
  apps: [
    "home",
    "expenses",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "expenses.records",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "amount_total",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Expenses",
    subtext: "in the last 30 days",
    icon: "money",
    color: "danger",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "$36,480",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
